<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-pic :config="config" />
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "lpa-left",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: this.beans,
      config: {
        carousel:'page',
        startCharts: "",
        header: ["改善前", "改善后"],
        rowNum: 2,
        columnWidth: [500,500],

        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        var http = sessionStorage.getItem("http");
        for (var i = 0; i < this.dataList.length; i++) {
          var beforeImg = this.dataList[i]["beforeImg"];
          var afterImg = this.dataList[i]["afterImg"];
         // var beforeImg = this.dataList[i]["beforeImg"].split(",")[0];
          //var afterImg = this.dataList[i]["afterImg"].split(",")[0];
          //var beforeUrl = http + "/api/fs/file/" + beforeImg;
         // var afterUrl = http + "/api/fs/file/" + afterImg;
          var before = "<img style='width: 100%;height: 100%;background-size: cover;background-repeat: no-repeat center ;' src=" + beforeImg + " >";
          var after = "<img style='width: 100%;height: 100%;background-size: cover;background-repeat: no-repeat center;' src=" + afterImg + ">";
          var value = [before, after];
          data.push(value);
        }

        this.config = {
         // headerBGC:'#fff',
          carousel:'page',
          headerHeight:60,
          waitTime:5000,
          startCharts: "",
          header: ['<span style="color:#fff;font-size:30px">改善前</span>', '<span style="color:#9fe6b8;font-size:30px">改善后</span>'],
          rowNum: 1,
          columnWidth: [],
          align:['center','center'],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "MM/dd");
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/ei/component/ei-img-list.vue